module.exports = __webpack_public_path__ + "src/assets/textures/env/hut/hut_2k_bake.png";